import { useMemo } from 'react'

import {
  IconA2a,
  IconAsyncApi,
  IconGraphQl,
  IconGrpc,
  IconMcpGray,
  IconOpenApi
} from '@smartbear/swagger-portal-component-library'

import { CommonSearchResultTile, HighlightedTitle } from '../CommonSearchResultTile'
import {
  isA2a,
  isAsyncApi,
  isDefinitionMarkdown,
  isGraphQl,
  isGrpc,
  isMcp
} from '~/portal/components/SearchModal/helpers'
import { SearchResult } from '~/portal/types/search'

interface ApiSearchResultTileProps {
  result: SearchResult
  onClose: () => void
  tileKey: string
}

export const ApiSearchResultTile = ({ result, onClose, tileKey }: ApiSearchResultTileProps) => {
  const anchorId = isDefinitionMarkdown(result) ? result.componentAnchorId : undefined

  const url = anchorId
    ? `/${result.product.slug}/${result.href}#${encodeURIComponent(anchorId)}`
    : `/${result.product.slug}/${result.href}#top`

  const icon = useMemo(() => {
    if (isGraphQl(result)) {
      return <IconGraphQl />
    }
    if (isAsyncApi(result)) {
      return <IconAsyncApi />
    }
    if (isMcp(result)) {
      return <IconMcpGray />
    }
    if (isA2a(result)) {
      return <IconA2a />
    }
    if (isGrpc(result)) {
      return <IconGrpc />
    }
    return <IconOpenApi />
  }, [result.contentType])

  const titleContent = <HighlightedTitle titleSnippet={result.titleSnippet} />

  return (
    <CommonSearchResultTile
      result={result}
      onClose={onClose}
      tileKey={tileKey}
      icon={icon}
      url={url}
      titleContent={titleContent}
    />
  )
}
